import {QueryState} from '../../../../../_dashboard/helpers'

const SORT_FIELD_MAP: Record<string, string> = {
  circuitName: 'circuitName',
  clientName: 'clientName',
  totalPrice: 'totalPrice',
  status: 'status',
  createdAt: 'createdAt',
}

export function buildMailOrdersListQuery(state: QueryState): Record<string, string | number> {
  const search = typeof state.search === 'string' ? state.search.trim() : ''

  const params: Record<string, string | number> = {
    page: state.page ?? 0,
    limit: state.size ?? 10,
    size: state.size ?? 10,
  }

  if (search) {
    params.search = search
  }

  if (state.status) {
    params.status = state.status
  }

  if (state.createdFrom) {
    params.createdFrom = state.createdFrom
  }

  if (state.createdTo) {
    params.createdTo = state.createdTo
  }

  if (state.sort && SORT_FIELD_MAP[state.sort]) {
    params.sortBy = SORT_FIELD_MAP[state.sort]
    params.sortDirection = state.order === 'desc' ? 'desc' : 'asc'
  }

  return params
}
